import { AttachmentSender } from '@shared/models/enums/attachments'
import { MessagePayloadOption } from '@shared/models/one-of-okind/message-payload-option'
import { IAttachment } from '@shared/models/proto/base/attachment'
import { IMessagePayloadBotPayload } from '@shared/models/proto/base/messages'
import { Nullable } from '@shared/models/types/primary'
import { getMessageTypeByContentType } from '@shared/utils/helpers/attachments/get-attachment-type'

import { MessageType } from '@protos/chat/message_type_pb'

export const processUserAttachment = (userAttachment: IAttachment[]) => {
  const {
    contentType,
    fileName: name,
    url,
    quickSignDocument,
  } = userAttachment[0]
  const fileName = name || quickSignDocument?.signName || ''
  const messageType = getMessageTypeByContentType(contentType, url)

  const annotation = quickSignDocument?.latestSigner?.annotation || ''

  return {
    messageType,
    fileName,
    url,
    annotation,
    quickSignDocument,
  }
}

export const processBotAttachment = (
  botPayloadAttachments: Nullable<IMessagePayloadBotPayload>,
  botMessageType?: MessageType
) => {
  const mediaPayload =
    botPayloadAttachments?.option?.case === MessagePayloadOption.media
      ? botPayloadAttachments.option.value
      : null

  const filePayload =
    botPayloadAttachments?.option?.case === MessagePayloadOption.file
      ? botPayloadAttachments.option.value
      : null

  return {
    url: mediaPayload?.url ?? filePayload?.url ?? '',
    fileName: mediaPayload?.filename ?? filePayload?.filename ?? '',
    messageType: botMessageType,
  }
}

export const attachmentFactory = (
  sender: AttachmentSender,
  botPayloadAttachments: Nullable<IMessagePayloadBotPayload>,
  userAttachment?: IAttachment[],
  botMessageType?: MessageType
) => {
  if (sender === AttachmentSender.User && userAttachment) {
    return processUserAttachment(userAttachment)
  }

  if (sender === AttachmentSender.Bot) {
    return processBotAttachment(botPayloadAttachments, botMessageType)
  }
}
